import { isString, getElementAs, isFunction, htmlEncode } from './utils';
export const pushJSONToForm = (form, dynamicParams, cleanUp) => {
    var _a;
    const frm = isString(form) ? getElementAs(form) : form;
    if (frm !== null) {
        const children = frm.children;
        if (cleanUp === true) {
            for (let i = children.length - 1; i >= 0; i--) {
                frm.removeChild(children[i]);
            }
        }
        for (const key in dynamicParams) {
            if (dynamicParams.hasOwnProperty(key)) {
                const currentValue = (_a = dynamicParams[key]) !== null && _a !== void 0 ? _a : '';
                let found = false;
                for (let j = 0; j < children.length; j++) {
                    if (children[j].id === key) {
                        children[j].value = currentValue;
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    appendFormWith(frm, key, currentValue);
                }
            }
        }
    }
};
export const appendFormWith = (form, id, value) => {
    try {
        const translatedValue = value !== null && value !== void 0 ? value : '';
        let inputElement = isFunction(form.querySelector) ?
            form.querySelector(`#${id}`) : getElementAs(id);
        if (inputElement !== null) {
            inputElement.value = htmlEncode(translatedValue);
        }
        else {
            if (navigator.userAgent.indexOf('MSIE 7') !== -1) {
                try {
                    inputElement = document.createElement(`<input type='hidden' id='${htmlEncode(id)}'`
                        + ` name='${htmlEncode(id)}' value='${htmlEncode(translatedValue)}' />`);
                }
                catch (e) {
                }
            }
            if (inputElement === null) {
                inputElement = document.createElement('input');
                inputElement.type = 'hidden';
                inputElement.name = htmlEncode(id);
                inputElement.id = htmlEncode(id);
                inputElement.value = htmlEncode(translatedValue);
            }
            form.appendChild(inputElement);
        }
    }
    catch (e) { }
};
export const post = (form, getURL, cleanForm = true, target) => {
    const [url, parameters] = getURL.split('?');
    let paramPairs = [];
    const params = {};
    if (parameters !== undefined) {
        paramPairs = parameters.split('&');
        paramPairs.forEach(pair => {
            const [key, value] = pair.split('=');
            params[key] = value === undefined ? '' : decodeURIComponent(value);
        });
    }
    pushJSONToForm(form, params, cleanForm);
    form.method = 'post';
    form.action = url;
    form.setAttribute('lastKnownURL', getURL);
    if (target !== undefined) {
        form.target = target.name;
    }
    form.submit();
};
